import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Fa from 'react-fontawesome';
import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import OwnerCell from '../owner-cell';
import OwnerCell2 from '../owner-cell/owner-cell-2';
import Avatar from '../avatar';
import { getCRMBaseUrl, getUserCurrentOrganization } from '../../modules/Auth/AuthReducer'
import styles from './styles.css';
import UniModal from '../uni-modal';
import { getOwnerUrl } from '../../util/crm-url';

class SaleRepsNameRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  renderTooltip(owner) {
    const { data } = this.props;
    if (!data) {
      return null;
    }

    const id = `${(data.opportunity_id || data.account_id)}-${owner.user_id}`;
    return (
      <Tooltip id={`owner-${id}`} className={styles.ownerTooltip}>
        <div className='text-left' style={{ padding: '10px 0' }}>
          <OwnerCell owner={owner} showFullEmail />
        </div>
      </Tooltip>
    );
  }

  render() {
    const {
      value, data, crmBaseUrl,
      isAccountOwner, displayStatus,
      isOwner, detailUrl, showAvatar,
      organization,
      popover,
    } = this.props;

    if (!data) {
      return value;
    }

    let owner = value;
    if (data) {
      if (isOwner) {
        owner = data;
      } else if (isAccountOwner && data.account && data.account.owner) {
        ({ owner } = data.account);
      } else if (!isAccountOwner && data.owner) {
        ({ owner } = data);
      }
    }

    if (owner) {
      const isHashed = owner.is_hashed || owner.is_gdpr_hashed;
      const shouldShowLink = !isHashed
        && crmBaseUrl !== null
        && owner.user_id != null // includes undefined - MW 2023-04-24
        && organization.type !== 'hubspot';

      let url = null;
      if (shouldShowLink) {
        url = getOwnerUrl(organization, owner);
      }

      let display = (<span>{value}</span>);
      if (popover) {
        return (
          <UniModal anchor={display}>
            <OwnerCell2 url={url} key={owner.user_id} owner={owner} />
          </UniModal>
        );
      }

      if (shouldShowLink) {
        display = (<a rel="noreferrer" target="_blank" href={url}>{display}</a>);
      }

      const tip = this.renderTooltip(owner);

      let status = null;
      const active = owner.is_active || owner.active;
      if (displayStatus) {
        status = (
          <span>
            <Fa
              name={active ? 'star' : 'star-o'}
              className={active ? 'text-warning' : 'text-muted'}
            />
            &nbsp;
          </span>
        );
      }
      let userAvatar = null;
      if (showAvatar) {
        userAvatar = (
          <span>
            <Avatar user={owner} small />
          </span>
        );
      }

      let comp = (
        <span>
          {status}
          {userAvatar}
          {display}
        </span>
      );
      if (detailUrl) {
        comp = <Link to={detailUrl}>{comp}</Link>;
      }
      return (
        <OverlayTrigger
          rootClose={popover}
          trigger={popover ? ['click'] : ['hover', 'focus']}
          placement='top'
          overlay={tip}
          onEntering={popover ? this.onEntering : () => {}}
          onEntered={popover ? this.onEntered : () => {}}
          onExited={popover ? this.onExited : () => {}}
        >
          {comp}
        </OverlayTrigger>
      );
    }

    return <span>{value}</span>;
  }
}

SaleRepsNameRenderer.propTypes = {
  value: PropTypes.string,
  data: PropTypes.shape({
    opportunity_id: PropTypes.string,
    account_id: PropTypes.string,
    owner: PropTypes.shape({
      user_id: PropTypes.string,
    }),
    account: PropTypes.shape({
      owner: PropTypes.shape({}),
    }),
  }),
  organization: PropTypes.shape({
    type: PropTypes.string,
  }).isRequired,
  crmBaseUrl: PropTypes.string,
  isAccountOwner: PropTypes.bool,
  isOwner: PropTypes.bool,
  displayStatus: PropTypes.bool,
  detailUrl: PropTypes.string,
  showAvatar: PropTypes.bool,
  popover: PropTypes.bool,
};
SaleRepsNameRenderer.defaultProps = {
  value: null,
  data: null,
  crmBaseUrl: null,
  isAccountOwner: false,
  isOwner: false,
  displayStatus: false,
  detailUrl: null,
  showAvatar: false,
  popover: false,
};

function mapStateToProps(state) {
  return {
    crmBaseUrl: getCRMBaseUrl(state),
    organization: getUserCurrentOrganization(state),
  };
}

export default connect(mapStateToProps, null, null, { forwardRef: true })(
  SaleRepsNameRenderer,
);
